import apiClient from "../../../../lib/api_client";

export const GetScannedDesign = async (scannedDesign) => {

  try {
    const response = await apiClient.get(
      `/getScanOrSearchDesignData?styleNumber=${scannedDesign}`,
    );

    if (response?.status === 200) {
      return response.data;
    } else {
      console.warn("Failed to scan design", response?.statusText || "Unknown error");
      return null;
    }
  } catch (error) {
    console.error("Error Scanning Design ", error?.response?.data || error.message);
    throw error;
  }
};
